var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.disabled)?_c('strong',{staticClass:"v-schedule__mainmsg r-strong"},[_vm._v("\n    Выберите время, в которое вы готовы принять пациентов\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }